module.exports = __webpack_public_path__ + "img/upload.345c0018.png";